import { Drawer } from '@mui/material';

import { PRODUCT_PICKER_WIDTH } from 'main-layout-op/_constants';
import { useMainLayout } from 'main-layout-op/_providers/MainLayoutProvider';

import { ProductPickerSidebar } from './sidebar/ProductPickerSidebar/ProductPickerSidebar';

export function ProductPickerDrawer() {
  const { isProductPickerOpen, closeProductPicker } = useMainLayout();

  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={isProductPickerOpen}
      onClose={closeProductPicker}
      PaperProps={{ sx: { width: PRODUCT_PICKER_WIDTH } }}
      slotProps={{ backdrop: { sx: { bgcolor: 'rgba(0,0,0,0.2)' } } }}
    >
      <ProductPickerSidebar />
    </Drawer>
  );
}
